import { FindControlSearchParameterItemDto } from './FindControlSearchParameterItemDto';

export class FindControlRequiredSearchParametersDto {
    RequiredSearchParameters: FindControlSearchParameterItemDto[];
}
